// extracted by mini-css-extract-plugin
var _1 = "KEyrofTPyAhIimrsHvwT";
var _2 = "OcT7WzKypu5O5gCStFrO";
export { _1 as "letter", _2 as "pinClass" }
